'use client';

import {
  FileTree,
  FileTreeFile,
  FileTreeFolder,
} from '@/components/ai-elements/file-tree';
import { cn } from '@/lib/utils';
import { FileTypeIcon } from './file-icons';
import type { TreeNode } from './types';

function renderNodes(nodes: TreeNode[]): React.ReactNode {
  return nodes.map((node) =>
    node.type === 'folder' ? (
      <FileTreeFolder key={node.path} path={node.path} name={node.name}>
        {renderNodes(node.children)}
      </FileTreeFolder>
    ) : (
      <FileTreeFile
        key={node.path}
        path={node.path}
        name={node.name}
        icon={<FileTypeIcon path={node.path} mime={node.file.mime} />}
        data-file-path={node.path}
      />
    ),
  );
}

export function FileTreeView({
  nodes,
  selectedPath,
  onSelect,
  expanded,
  onExpandedChange,
  className,
}: {
  nodes: TreeNode[];
  selectedPath: string | null;
  onSelect: (path: string) => void;
  expanded: Set<string>;
  onExpandedChange: (next: Set<string>) => void;
  className?: string;
}) {
  return (
    <FileTree
      className={cn('border-0 bg-transparent p-0 text-[13px]', className)}
      selectedPath={selectedPath ?? undefined}
      onSelect={onSelect}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
    >
      {renderNodes(nodes)}
    </FileTree>
  );
}
